// @ts-nocheck
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useMediaQuery } from 'react-responsive';
import {
  SkeletonFeaturedOffers,
  SkeletonFiltersWrapper,
  SkeletonHeaderWrapper,
  SkeletonFeaturedOffersTitle,
  SkeletonWrapper,
  SkeletonFeaturedOffersSelector,
} from './Skeleton.styles';
import { device } from '../../styles/devices';

const SkeletonLoader: React.FC = () => {
  const isLaptop = useMediaQuery({ query: device.laptop });

  const SkeletonTitle = <Skeleton className="title" count={1} height={isLaptop ? 24 : 20} />;
  const SkeletonHeader = <Skeleton className="header" count={1} height={isLaptop ? 60 : 48} />;
  const SkeletonDescription = (
    <Skeleton className="description" count={isLaptop ? 2 : 5} height={isLaptop ? 24 : 20} />
  );
  const SkeletonSkipTo = <Skeleton className="skipTo" count={1} height={62} />;
  const SkeletonFeaturedTitle = <Skeleton className="title" count={1} height={48} />;
  const SkeletonFeaturedTile = (
    <Skeleton className="tile" count={1} height={isLaptop ? 360 : 610} />
  );
  const SkeletonFeaturedSelector = <Skeleton className="selector" count={1} height={48} />;

  return (
    <div style={{ flex: 1 }}>
      <SkeletonTheme color="rgba(0, 0, 0, 0.05)" highlightColor="#f5f5f5">
        <SkeletonWrapper>
          <SkeletonHeaderWrapper>
            {SkeletonTitle}
            {SkeletonHeader}
            {SkeletonDescription}
          </SkeletonHeaderWrapper>
          <SkeletonFiltersWrapper>{SkeletonSkipTo}</SkeletonFiltersWrapper>
          <SkeletonFeaturedOffersTitle>{SkeletonFeaturedTitle}</SkeletonFeaturedOffersTitle>
          {!isLaptop && (
            <SkeletonFeaturedOffersTitle>{SkeletonFeaturedSelector}</SkeletonFeaturedOffersTitle>
          )}
          <SkeletonFeaturedOffers>{SkeletonFeaturedTile}</SkeletonFeaturedOffers>
          {isLaptop && (
            <SkeletonFeaturedOffersSelector>
              {SkeletonFeaturedSelector}
            </SkeletonFeaturedOffersSelector>
          )}
        </SkeletonWrapper>
      </SkeletonTheme>
    </div>
  );
};

export default SkeletonLoader;
